import type { IEpisode, IListResponse } from '@dakedake/types'
import { request } from '@umijs/max'

/** 添加分集 POST /backend/episode/add */
export async function episodeAdd(body: IEpisode, options?: Record<string, any>) {
  return request<{ data: IEpisode, success: boolean, message: string }>('/backend/episode/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 添加分集 POST /backend/episode/adds */
export async function episodeAdds(body: IEpisode[], options?: Record<string, any>) {
  return request<{ data: IEpisode[], success: boolean, message: string }>('/backend/episode/adds', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 更新分集 POST /backend/episode/edit */
export async function episodeEdit(body: IEpisode, options?: Record<string, any>) {
  return request<{ data: IEpisode, success: boolean, message: string }>('/backend/episode/edit', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 获取章节关联数据 GET /backend/episode/associated/:id */
export async function episodeGetAssociatedData(id: number, options?: Record<string, any>) {
  return request<{ data: any, success: boolean, message: string }>(`/backend/episode/associated/${id}`, {
    method: 'GET',
    ...options
  })
}

/** 删除分集 POST /backend/episode/delete */
export async function episodeDelete(body: { id?: number }, options?: Record<string, any>) {
  return request<{ data: any, success: boolean, message: string }>(`/backend/episode/${body.id}`, {
    method: 'DELETE',
    ...options
  })
}

/** 获取分集列表 GET /backend/episode/list */
export async function episodeList(
  params: {
    /** 剧集ID */
    aid?: number
    /** 排序字段 */
    order?: string
    /** 排序方向 */
    orderBy?: string
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
  },
  options?: Record<string, any>
) {
  return request<IListResponse<IEpisode>>('/backend/episode/list', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}
